// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"164":"room-board.page","569":"room-qr.page","831":"wish.page"}[chunkId] || chunkId) + "." + {"14":"9bb85308","164":"53172c63","467":"997c7895","569":"ff80ff74","786":"91349bbf","831":"9445b95f","883":"ed566184"}[chunkId] + ".chunk.js";
};